export default {
  id: 'googlePay',
  cardType: 'Google Pay',
  source: 'google_pay',
  isPrimary: true,
  isActive: false,
  name: 'GOOGLE PAY',
  isGooglePay: true
};
